import './PersonalRelations.scss'
import Store from 'state/Store';
import { connect } from 'react-redux';
import { getPersonalDetails } from 'state/personalDetails/PersonalDetailsSelectors';
import { setPersonalDetails } from 'state/personalDetails/PersonalDetailsActions';
import { isFieldRequired } from 'utils/Validation';
import React, {
  useEffect
} from 'react';
import {
  setCanContinueFalse,
  setCanContinueTrue,
} from 'state/canContinue/CanContinueActions';
import {
  ExecutorList,
  RelationshipList,
} from 'utils/Content';
import { LFEBeaconDropdown } from 'components/shared/LFEBeaconComponents';

const PersonalRelations = ({ personalDetails }) => {
  const { pRelationToDeceased, pExecutor } = personalDetails
  const handleChange = (id,event) =>{
    if (event && event.target && id){
      Store.dispatch(setPersonalDetails(id, event.target.value))
    }
  }
  
  useEffect(()=>{
    if (pRelationToDeceased && isFieldRequired(pRelationToDeceased) && pExecutor && isFieldRequired(pExecutor)){
      Store.dispatch(setCanContinueTrue())
    }else{
      Store.dispatch(setCanContinueFalse())
    }
  },[ pExecutor, pRelationToDeceased, personalDetails ])
  return (
      <div className="personal-details-relations">
        <div className="dn-page-subtitle"
             data-testid="pRelation-header">
          Additional details
        </div>
        <div className="personal-details-fields">

        <div className="relationship-personal-details-info">
          <LFEBeaconDropdown id="pRelationToDeceased"
                             className="dn-input-field pRelationToDeceased blocked_data"
                             required={true}
                             data-testid="pRelationToDeceased"
                             label="Relationship to the deceased"
                             value={pRelationToDeceased}
                             onBeaconChange={(event) => handleChange('pRelationToDeceased', event)}
                             errorsMap={{ required: 'Required' }}>
            <option value={''}>Choose a relationship</option>
            {RelationshipList.map((Relationship)=>{
              return <option value={Relationship}
                             key={`${Relationship}-pRelationToDeceased`}>{Relationship}</option>
            })}
          </LFEBeaconDropdown>
          <LFEBeaconDropdown id="pExecutor"
                             className="dn-input-field pExecutor blocked_data"
                             required={true}
                             data-testid="pExecutor"
                             label="Are you the executor?"
                             value={pExecutor}
                             onBeaconChange={(event) => handleChange('pExecutor', event)}
                             errorsMap={{ required: 'Required' }}>
            <option value={''}
                    selected={pExecutor === ''}>Choose one</option>
            {ExecutorList.map((options)=>{
              return <option value={options}
                             key={`${options}-pExecutor`}
                             selected={pExecutor === options}>{options}</option>
            })}
          </LFEBeaconDropdown>
        </div>
      </div>
      </div>
  )
}

const mapStateToProps = state => ({
  personalDetails: getPersonalDetails(state)
});

export default connect(mapStateToProps)(PersonalRelations);